import { format, parseISO } from "date-fns";

export function formatDate(date: string) {
  return format(parseISO(date), "MMM d");
}

export function formatDateWithYear(date: string) {
  return format(parseISO(date), "MMM d, yyyy");
}
